import { type ReactElement, type ReactNode, useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/app/store";
import { useForm, SubmitHandler } from "react-hook-form";
import Modal from "src/components/Modal";
import Button from "src/components/Button";
import { apiClient } from "src/utils/Api/apiClient";
import { AppDispatch } from "src/app/store";
import { getEndUsersByDealerIDForReports } from "../../hooks/endUsersForReports";
import { getEndUsersByDealerIDForDetailedReports } from "../../hooks/endUsersForDetailedReports";
import { DealerType } from "src/features/admin/types/DealerType";
import Spinner from "src/components/Spinner";

export interface DealerReportModalProps {
        title: string,
        isOpen: boolean,
        onGenerate: (type: string, invoice: string) => void,
        onClose: () => void,
        dealerId?: string,
        children?: ReactNode
}

export default function DealerReportModal(props: DealerReportModalProps): ReactElement {
        const dispatch = useDispatch<AppDispatch>();
        const { dealers } = useSelector((state: RootState) => state.dealers);
        const [reportType, setReportType] = useState("compact");
        const [invoiceNumber, setInvoiceNumber] = useState("");
        const [selectedDealer, setDealer] = useState<DealerType>();
        const { endUserForDetailedReportsLoading, endUserForDetailedReportsError, endUserForDetailedReports } = useSelector((state: RootState) => state.endUserForDetailedReports);
        const { endUserForReportsLoading, endUserForReports, endUserForReportsError } = useSelector((state: RootState) => state.endUserForReports);

        const onSubmit = async () => {
                try {
                        props.onGenerate(reportType, invoiceNumber);
                        props.onClose()
                } catch (dealerError: any) {
                        console.log(dealerError);
                }
        }

        const selectReportType = (event: React.ChangeEvent<HTMLSelectElement>) => {
                if (event.target.value === "compact") {
                        dispatch(getEndUsersByDealerIDForReports(props.dealerId));
                }
                else {
                        dispatch(getEndUsersByDealerIDForDetailedReports(props.dealerId));
                }
                setReportType(event.target.value);
        }

        const setInvoiceNumberFn = (event: React.ChangeEvent<HTMLInputElement>) => {
                setInvoiceNumber(event.target.value);
        }

        useEffect(() => {
                const dealer = dealers.find(a => a.Id === Number(props.dealerId));
                setDealer(dealer);
                dispatch(getEndUsersByDealerIDForReports(props.dealerId));
        }, [])

        return <>
                <Modal isOpen={props.isOpen} modalSize="sm" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        {!endUserForReportsLoading && !endUserForDetailedReportsLoading ? (
                                < div className="flex flex-col gap-4">
                                        <div className="mb-4 flex flex-row">
                                                <label className="block text-sm">Dealer Name</label>
                                                <input className="w-full px-3 py-2 text-center border rounded-lg" value={selectedDealer?.Name} disabled={true} />
                                        </div>
                                        <div className="mb-4 flex flex-row">
                                                <label className="block text-sm">Invoice Number</label>
                                                <input className="w-full px-3 py-2 text-center border rounded-lg" type="number" value={invoiceNumber} onChange={setInvoiceNumberFn} />
                                        </div>
                                        <div className="flex">
                                                <label className="block text-sm">Type of Report:</label>
                                                <select className="w-full px-3 py-2 border rounded-lg" value={reportType} onChange={selectReportType}>
                                                        <option key="1" value="compact">Compact</option>
                                                        <option key="2" value="detailed">Detailed</option>
                                                </select>
                                        </div>
                                        <div className="flex justify-center">
                                                <Button className="" size="lg" type="button" buttonStyle="primary" handleClick={onSubmit}>Save</Button>
                                        </div>
                                </div>) : <Spinner title="Loading" />
                        }
                </Modal>
        </>
}
